<template>
  <div>
    <div v-if="payment.href">
      <RevLink
        class="body-2"
        target="_blank"
        :to="payment.href"
        :underlined="false"
      >
        {{ i18n(payment.label) }}
      </RevLink>
      <PaymentIcons class="pt-6" />
    </div>

    <div v-else class="body-2">
      <span>
        {{ i18n(payment.label) }}
      </span>
      <PaymentIcons class="pt-6" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { PaymentIcons } from '@backmarket/nuxt-layer-payment/methods'
import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevLink } from '@ds/components/Link'

interface Props {
  payment: {
    label: I18nDefinition
    href?: string
  }
}

defineProps<Props>()

const i18n = useI18n()
</script>
